import React, {useEffect, useRef, useState} from 'react';

export default function ConfirmPopup({
	showConfirmPopup = false,
	closeAnimationMs = 300,
	showButtonConfirm = false,
	cofirmConfirmPopup = () => {},
	showButtonDelete = false,
	deleteConfirmPopup = () => {},
	footerChildren = null,
	closeConfirmPopup = () => {},
	infoHeader = '&nbsp;',
	infoMain = '&nbsp;',
	popupClassName = '',
	popupContentClassName = '',
	bodyClassName = '',
	bodyInnerClassName = '',
	children
}) {
	const [shouldRender, setShouldRender] = useState(showConfirmPopup);
	const [isClosing, setIsClosing] = useState(false);
	const closeTimeoutRef = useRef(null);

	useEffect(() => {
		return () => {
			if (closeTimeoutRef.current) {
				clearTimeout(closeTimeoutRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (closeTimeoutRef.current) {
			clearTimeout(closeTimeoutRef.current);
			closeTimeoutRef.current = null;
		}

		if (showConfirmPopup) {
			setShouldRender(true);
			setIsClosing(false);
			return;
		}

		if (!shouldRender) {
			return;
		}

		if (closeAnimationMs > 0) {
			setIsClosing(true);
			closeTimeoutRef.current = setTimeout(() => {
				setShouldRender(false);
				setIsClosing(false);
				closeTimeoutRef.current = null;
			}, closeAnimationMs);
			return;
		}

		setShouldRender(false);
		setIsClosing(false);
	}, [closeAnimationMs, showConfirmPopup, shouldRender]);

	if (!shouldRender) {
		return null;
	}

	return (
		<>
			<div className={`popup${popupClassName !== '' ? ` ${popupClassName}` : ''}${isClosing ? ' popup--closing' : ''}`} style={{zIndex: '2001'}}>
				<div className={`popup_content${popupContentClassName !== '' ? ` ${popupContentClassName}` : ''}${isClosing ? ' popup_content--closing' : ''}`}>
						<div className="popup_content_in_head">
							<div className="popup_content_in_head_in">{infoHeader}</div>
							<img
								alt=""
								className="popup_content_in_head_in-close"
								onClick={() => {
									closeConfirmPopup();
								}}
							/>
						</div>
						<div className={`popup_content_in_body${bodyClassName !== '' ? ` ${bodyClassName}` : ''}`}>
							<div className={`popup_content_in_body_in${bodyInnerClassName !== '' ? ` ${bodyInnerClassName}` : ''}`}>
								<div className="zero h1" />
								<span dangerouslySetInnerHTML={{__html: infoMain}}></span>
								{children}
								<div className="zero h1" />
							</div>
						</div>
						<div className="popup_content_in_foot">
							<div className="popup_content_in_foot_in">
								{footerChildren}

								{showButtonConfirm ? (
									<button
										type="button"
										className="button green mr_2"
										onClick={() => {
											cofirmConfirmPopup();
										}}
									>
										Potvrdit
									</button>
								) : (
									''
								)}

								{showButtonDelete ? (
									<button
										type="button"
										className="button red mr_2"
										onClick={() => {
											deleteConfirmPopup();
										}}
									>
										Smazat
									</button>
								) : (
									''
								)}

								<button
									type="button"
									className="button"
									onClick={() => {
										closeConfirmPopup();
									}}
								>
									Zpět
								</button>
							</div>
						</div>
				</div>
			</div>
		</>
	);
}
